//this component is used for datasetFilter coulmn in Right side of canvas table

import { UserFilterDatasetProps } from './types/UserFilterDatasetInterfaces';
import FilterElement from './FilterElement';
import { RootState } from '../../redux';
import { useSelector } from 'react-redux';
const UserFilterDataset = ({
  //props
  editMode,

  // list of fliters addedby user for dataset
  filters,
  setDataSetFilterArray,
  canEdit,
}: UserFilterDatasetProps) => {
  const selectedTables = useSelector((state: RootState) => state.dataset.selectedTables);
  const getFlatFileIdByTableId = (tableId: string): string => {
    const found = selectedTables.find((item) => item.id === tableId);
    return found ? found.flatFileId : '';
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '1rem auto' }}>
      {filters &&
        filters.length > 0 &&
        filters.map((filter) => {
          const table = selectedTables.find((table) => table.id === filter.tableId);
          if (!table) return null;
          return (
            <FilterElement
              key={filter.uid}
              filter={filter}
              flatFileId={getFlatFileIdByTableId(filter.tableId)}
              dbConnectionId={table!.connectionId}
              editMode={editMode}
              setDataSetFilterArray={setDataSetFilterArray}
              schema={table!.schema}
              canEdit={canEdit}
            />
          );
        })}
    </div>
  );
};

export default UserFilterDataset;
